import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import FaIcon from "~/components/FaIcon";
import { Icon } from "~/components/links/MainNavLink";

import { ScreenReaderText } from "~/styles/screenReaderText";

import transition from "~/utilities/transition";

const getColor = ({ theme, buttonColor }) => {
    let color = theme.colors.typography.defaultLightBackground;

    if (buttonColor === "white") {
        color = theme.palette.white;
    }

    return color;
};

const Label = styled.span`
    ${transition({}, "border-bottom")};
    border-bottom: 2px solid
        ${({ theme, isNavOpened }) =>
            isNavOpened ? theme.palette.teal : `transparent`};
    font-size: ${({ icon }) => (icon ? `1.6rem` : `2rem`)};
    display: flex;
    align-items: center;
    color: inherit;
    white-space: nowrap;
    line-height: 1.42;
`;

const Button = styled.button`
    display: flex;
    align-items: center;
    color: ${getColor};

    &:hover,
    &:focus {
        ${Label} {
            border-bottom: ${({ theme }) => `2px solid ${theme.palette.teal}`};
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        padding: ${({ icon }) => (icon ? `2px 0` : `28px 15px`)};
    }
`;

const ChevronIcon = styled(FaIcon)`
    color: inherit;
    font-size: ${({ icon }) => (icon ? `1rem` : `1.2rem`)};
    margin-left: 10px;
    vertical-align: middle;
    cursor: pointer;
    ${transition({ speed: 250 }, "transform")};
    transform: ${({ isNavOpened }) =>
        isNavOpened ? `rotate(0.5turn)` : `none`};
`;

const DropDownNavButton = ({
    linkLabel = "",
    screenReaderText = "",
    onClick = () => {},
    icon = "",
    isNavOpened = null,
    buttonColor = null,
    ...props
}) => {
    const buttonProps = {
        onClick,
        type: "button",
        isNavOpened,
        icon,
        buttonColor,
        ...props,
    };

    return (
        <Button {...buttonProps}>
            {screenReaderText && (
                <ScreenReaderText>{screenReaderText}</ScreenReaderText>
            )}
            <Label {...{ icon, isNavOpened }}>
                {icon ? <Icon name={icon} /> : null}
                {linkLabel}
            </Label>
            <ChevronIcon
                name="chevron-down"
                iconLibrary="fas"
                {...{ isNavOpened }}
            />
        </Button>
    );
};

DropDownNavButton.propTypes = {
    buttonColor: PropTypes.string,
    linkLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    screenReaderText: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string,
    isNavOpened: PropTypes.bool,
};

export default DropDownNavButton;
